import { useEffect, useRef, useState } from "react";
import "./input-upload.css";
import { Button } from "../button";
import { Icon } from "../icon";

interface UploadProps {
  description?: string;
  entityId?: string;
  label: string;
  name?: string;
  value?: string | null;
  onChange?: (file: File | null) => void;
}

export default function InputUpload({
  description = "Ajouter un fichier",
  entityId,
  label,
  name,
  value,
  onChange,
}: UploadProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [preview, setPreview] = useState<string | null>(
    !!value ? value : null
  );
  const [isPdf, setIsPdf] = useState(false);
  const [fileName, setFileName] = useState("");


  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;
    onChange?.(file);

    setPreview(URL.createObjectURL(file));
    setIsPdf(file.type === "application/pdf");
    setFileName(file.name);

  };

  const removePhoto = () => {
    onChange?.(null);
    setPreview(null);
    setIsPdf(false);
    setFileName("");

    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  useEffect(() => {
    setPreview(value ?? null);
    setIsPdf(value?.toLowerCase().split("?")[0].endsWith(".pdf") ?? false);
    setFileName(
      value ? value.split("/").pop()?.split("?")[0] ?? "" : "");
  }, [value, entityId]);

  useEffect(() => {
    return () => {
      if (preview?.startsWith("blob:")) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  return (
    <div className="photo-upload">
      <p className="photo-upload-label">{label}</p>
    
      <input
        ref={inputRef}
        hidden
        type="file"
        accept="image/*, application/pdf"
        name={name}
        onChange={handleFileChange}
      />

      {!preview ? (
        <button
          type="button"
          className="photo-upload-placeholder"
          onClick={() => inputRef.current?.click()}
        >
          <Icon name="upload" size="small"/>
          {description}
        </button>
      ) : (
        <div className="photo-upload-preview">
          {isPdf ? (
            <div className="photo-upload-pdf-section">
              <div className="photo-upload-pdf">
                <Icon name="document" size="large" />
                <span>{fileName || "Certificat PDF"}</span>
              </div>
              <div onClick={removePhoto}>
                <Icon className="photo-upload-pdf-delete-icon" name="close"/>
              </div>
            </div>
          ) : (
            <>
              <img src={preview} alt="Aperçu du fichier" />
              <div className="photo-upload-actions">    
              <Button
                  label="Supprimer"
                  type="button"
                  onClick={removePhoto}
                  variant="secondary"
              />
              <Button
                  label="Modifier"
                  type="button"
                  onClick={() => inputRef.current?.click()}
              />
              </div>
          </>
          )}
          
        </div>
      )}
    </div>
  );
}